var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEggBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.001,
    cy: 5.5,
    r: 3,
    fill: "#F28520"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9C19 9.74556 18.7669 10.4367 18.3696 11.0044C17.7368 11.9087 15.3961 11.0044 15.3961 11.0044C15.3961 11.0044 13.2632 11.9087 12.6304 11.0044C12.2331 10.4367 12 9.74556 12 9C12 7.067 13.567 5.5 15.5 5.5C17.433 5.5 19 7.067 19 9Z",
    fill: "#EA1763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.001 9C14.001 9.73932 13.7717 10.4251 13.3805 10.9901C12.7488 11.9024 10.7935 10.7746 10.7935 10.7746C10.7935 10.7746 8.25319 11.9024 7.62147 10.9901C7.23021 10.4251 7.00098 9.73932 7.00098 9C7.00098 7.067 8.56798 5.5 10.501 5.5C12.434 5.5 14.001 7.067 14.001 9Z",
    fill: "#208C72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 20.5C19.001 21.3284 18.3294 22 17.501 22C16.6725 22 16.001 21.3284 16.001 20.5C16.001 19.6716 16.6725 19 17.501 19C18.3294 19 19.001 19.6716 19.001 20.5Z",
    fill: "#3360AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 20.5C10.001 21.3284 9.3294 22 8.50098 22C7.67255 22 7.00098 21.3284 7.00098 20.5C7.00098 19.6716 7.67255 19 8.50098 19C9.3294 19 10.001 19.6716 10.001 20.5Z",
    fill: "#3360AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0002 9.58588V9.58557H20.0002V12.4617C20.0002 14.6289 19.1387 16.6203 17.7397 18.0114C17.6609 18.004 17.581 18.0001 17.5002 18.0001C16.4217 18.0001 15.5027 18.6831 15.1521 19.6402C14.4775 19.8735 13.7552 20.0002 13.0002 20.0002C12.2453 20.0002 11.523 19.8735 10.8484 19.6402C10.4978 18.6831 9.5788 18.0001 8.50025 18.0001C8.41947 18.0001 8.33958 18.004 8.26076 18.0114C6.86182 16.6203 6.00025 14.6289 6.00025 12.4617C6.00025 11.8826 6.06105 11.2465 6.17149 10.5857L4.58579 9H3V7H5L5.70711 7.29289L9 10.5858L10.2929 9.29289L11.7071 9.29289L13 10.5858L14.2929 9.29289H15.7071L17 10.5858L18.0002 9.58582L18.0002 9.58588ZM18.0002 12.414L17.7071 12.7072L16.2929 12.7071L15 11.4142L13.7071 12.7071H12.2929L11 11.4142L9.70711 12.7071L8.29289 12.7071L8.00042 12.4146C8.00031 12.4304 8.00025 12.4461 8.00025 12.4617C8.00025 15.6031 10.318 18.0002 13.0002 18.0002C15.6825 18.0002 18.0002 15.6031 18.0002 12.4617V12.414Z",
    fill: "#3360AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggBasket);
export default __webpack_public_path__ + "static/media/egg-basket.e518426ae23061873f08b1b746c39e0e.svg";
export { ForwardRef as ReactComponent };